import { Routes } from '@angular/router';
import { SandboxComponent, SandboxWrapperComponent } from '@lms-approval/onehub-sandbox';
import { MsalGuard } from '@azure/msal-angular';
import { SANDBOX_ROUTES } from './constants';
import { IsRemoteEntryLoadedGuard } from './guards/is-remote-entry-loaded-guard.service';
import { RemoteLoaderComponent } from './components/remote-loader/remote-loader.component';
import { UserMappingComponent } from './components/user-mapping/user-mapping.component';

export const APP_ROUTING: Routes = [
  {
    path: SANDBOX_ROUTES.MAIN,
    component: SandboxWrapperComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: SANDBOX_ROUTES.MAIN,
        component: SandboxComponent,
        children: [
          {
            path: SANDBOX_ROUTES.TRACKING,
            children: [
              {
                path: '**',
                component: RemoteLoaderComponent,
                canActivate: [IsRemoteEntryLoadedGuard]
              }
            ]
          },
          {
            path: SANDBOX_ROUTES.USER_MAPPING,
            component: UserMappingComponent,
            pathMatch: "full"
          },
          {
            path: '**',
            redirectTo: '/tracking',
            pathMatch: "full"
          },
        ]
      }
    ]
  }
];
